/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';

import useFavorite from '@utils/useFavorite';

const withFavorites = () => WrappeddComponent => {
  const ComponentWithFavorites = props => {
    const { isFavorite, toggleFavorite } = useFavorite(
      props.id,
      props.isFavorite,
      props.onToggleFavorite
    );

    return (
      <WrappeddComponent
        {...props}
        isFavorite={isFavorite}
        handleFavorite={toggleFavorite}
      />
    );
  };

  ComponentWithFavorites.propTypes = {
    id: PropTypes.string.isRequired,
    isFavorite: PropTypes.bool.isRequired,
    onToggleFavorite: PropTypes.func
  };
  ComponentWithFavorites.defaultProps = {
    onToggleFavorite: () => {}
  };

  return ComponentWithFavorites;
};

export default withFavorites;
